<template>
  <div class="picker" :class="{ visible }">
    <a
      class="flag"
      :class="{ active: !level || level === 'None' }"
      @click="changePriority(null)"
    ></a>

    <a
      class="flag low"
      :class="{ active: level === 'Low' }"
      @click="changePriority('Low')"
    ></a>

    <a
      class="flag medium"
      :class="{ active: level === 'Medium' }"
      @click="changePriority('Medium')"
    ></a>

    <a
      class="flag high"
      :class="{ active: level === 'High' }"
      @click="changePriority('High')"
    ></a>
  </div>
</template>

<script>
export default {
  name: 'PriorityPicker',
  props: {
    level: String,
    visible: Boolean,
    changePriority: Function,
  },
  data() {
    return {
      delay: { show: 700, hide: 0 },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.picker {
  width: 124px;
  height: 36px;
  border-radius: 18px;
  border: 1px solid #e2e5ec;
  background: white;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  padding: 5px;
  position: absolute;
  top: 20px;
  left: -99999px;
  opacity: 0;
  box-shadow: 0 0 14px 2px rgba(41, 42, 44, 0.09);
  transition: top 0.4s, opacity 0.4s;

  &.visible {
    top: 34px;
    left: -11px;
    opacity: 1;
  }

  .flag {
    border-bottom: 1px solid transparent;
    width: 16px;
    height: 22px;
    margin: 0 5px;
    background-repeat: no-repeat;
    background-position: center left;
    background-size: 64px 16px;
    background-image: url(~@/assets/icons/flags.svg);
    padding: 6px 0;
    cursor: pointer;

    &.low {
      background-position: center left -16px;
    }

    &.medium {
      background-position: center left -32px;
    }

    &.high {
      background-position: center left -48px;
    }

    &:hover {
      border-bottom-color: #ccc;
    }

    &.active,
    &.active:hover {
      border-bottom-color: #222222;
    }
  }
}
</style>
